import React, { Component } from "react";
import posed from "react-pose";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import ExitToAppIcon from "@material-ui/icons/ExitToAppRounded";
import AccountCircleIcon from "@material-ui/icons/AccountCircleRounded";

import { PROFILE_PIC_STORAGE_URL } from "../../utils/Urls";
import { SETTING_PAGE_URL } from "../../utils/Route";
import { clearUserDetails } from "../../store/actionCreators/userDetails";
import { QUICK_TAB_OPTIONS } from "../../utils/Constants";

const styles = theme => ({
  DropdownContainerStyles: {
    width: "250px",
    backgroundColor: "white",
    boxShadow: "0px 0px 10px 1px rgba(0,0,0,0.75)",
    position: "absolute",
    cursor: "initial",
    textTransform: "none"
  },
  ProfileContainer: {
    position: "relative",
    margin: 5,
    padding: 5,
    textAlign: "center",
    backgroundColor: "#F37020",
    color: "black"
  },
  Icon: {
    color: "black"
  },
  ProfileName: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "5px",
    textTransform: "capitalize"
  },
  ProfileEmail: {
    fontSize: "14px",
    margin: "5px",
    color: "white"
  },
  ProfileImage: {
    height: "100px",
    width: "100px",
    display: "inline-block",
    marginTop: 15
  },
  MoreLabel: {
    textAlign: "center"
  },
  MenuItemWrapper: {
    paddingBottom: "8px",
    paddingTop: "8px"
  }
});

// Animation Wrapper
const DropdownContainer = posed.div({
  open: {
    top: "110%",
    right: "0%",
    opacity: 1,
    scale: 1
  },
  close: {
    top: "-500%",
    right: "-100px",
    opacity: 0,
    scale: 0
  }
});

const MenuItem = props => {
  return (
    <ListItem
      button
      style={{ paddingBottom: "8px", paddingTop: "8px" }}
      onClick={event => {
        props.clickHandler(event, props.label, props.route);
      }}
    >
      {props.icon && (
        <ListItemIcon>
          <props.icon className={props.iconStyles} />
        </ListItemIcon>
      )}
      <ListItemText
        primary={
          <Typography style={{ fontSize: "14px", fontWeight: "500" }}>
            {props.label}
          </Typography>
        }
        disableTypography
        className={props.labelStyles}
      />
    </ListItem>
  );
};

// Number of menu items to be shown initially
const LIMIT_COUNT = 3;

class MenuDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: true
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // We should collapse the menu items to its limit on close
    if (nextProps.pose === "close") {
      return {
        limit: true
      };
    }

    return null;
  }

  handleMenuOption = (event, option, route) => {
    switch (option) {
      case "Logout":
        this.props.logoutHandler();
        this.props.closeMenu();
        break;
      case "More":
        this.expandMenu();
        break;
      default:
        this.props.history.push(`${SETTING_PAGE_URL}/${route}`);
        this.props.closeMenu();
    }
  };

  expandMenu = () => {
    this.setState({ limit: false });
  };

  getDisplayName = () => {
    const { userid, name, employeeid } = this.props.userDetails;
    let possibleNameToBeDisplayed = [name, employeeid, userid];

    for (let value of possibleNameToBeDisplayed) {
      if (typeof value === "string" && value.trim() !== "") {
        return value;
      }
    }
  };

  render() {
    const { classes, userDetails, foodCourtSettings } = this.props;
    const { profile_picture = "" } = userDetails;
    const { extras } = foodCourtSettings.settings || {};
    const { hideLogout } = extras || {};
    const {
      DropdownContainerStyles,
      ProfileContainer,
      ProfileName,
      ProfileEmail,
      ProfileImage,
      MoreLabel,
      Icon
    } = classes;

    // Decides the number of options to be shown in the menu
    const limit = this.state.limit ? LIMIT_COUNT : QUICK_TAB_OPTIONS.length - 1;

    return (
      <DropdownContainer
        pose={this.props.pose}
        className={DropdownContainerStyles}
      >
        <div className={ProfileContainer}>
          {profile_picture ? (
            <img
              width="100px"
              height="100px"
              src={PROFILE_PIC_STORAGE_URL + profile_picture}
              style={{ borderRadius: 50 }}
            />
          ) : (
            <AccountCircleIcon
              className={ProfileImage}
              style={{ color: "white" }}
            />
          )}

          <p className={ProfileEmail}>{this.getDisplayName()}</p>
        </div>
        <Divider />
        <List component="nav">
          {QUICK_TAB_OPTIONS.slice(0, limit).map(item => {
            return (
              <MenuItem
                key={item.route}
                label={item.label}
                route={item.route}
                icon={item.icon}
                iconStyles={Icon}
                clickHandler={this.handleMenuOption}
              />
            );
          })}
          {this.state.limit && (
            <MenuItem
              label="More"
              clickHandler={this.handleMenuOption}
              labelStyles={MoreLabel}
            />
          )}
          {!hideLogout && (
            <React.Fragment>
              <Divider />
              <MenuItem
                label="Logout"
                icon={ExitToAppIcon}
                iconStyles={Icon}
                clickHandler={this.handleMenuOption}
              />
            </React.Fragment>
          )}
        </List>
      </DropdownContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    userDetails: state.userDetails || {},
    foodCourtSettings: state.foodCourtSettings || {}
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearUserDetails: () => {
      dispatch(clearUserDetails());
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MenuDropdown))
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/MenuDropdown.js